import { Search } from '@mui/icons-material';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';

import styles from './FilterTextField.module.scss';


export function FilterTextField(props: TextFieldProps) {
    return (
        <TextField
            {...props}
            variant="standard"
            FormHelperTextProps={{
                className: styles.searchHelperText
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Search />
                    </InputAdornment>
                )
            }}
        />
    );
}
